import { FC } from 'react';

type Props = {
  width?: number;
  height?: number;
  isSideBar?: boolean;
};

const ratioNewLogo = 457 / 173;

const Logo: FC<Props> = ({ width = 150, height = 100, isSideBar = false }: Props) => {
  if (isSideBar) {
    return <img src={'/logo.svg'} width={width} height={height} alt="PYA Logo" loading="lazy" />;
  }
  if (width / height !== ratioNewLogo) height = width / ratioNewLogo;

  return <img src={'/logo-new.png'} width={width} height={height} alt="PYA Logo" loading="lazy" />;
};

export default Logo;
